import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './styles/index.scss'
import VueSplide from '@splidejs/vue-splide';
import '@splidejs/splide/dist/css/splide.min.css';
import i18n from "./helpers/i18n"
import { createHead } from '@vueuse/head'
const head = createHead()

window.store = store

createApp(App).use(store).use(router).use(head).use(VueSplide).use(i18n()).mount('#app')
